import { render, staticRenderFns } from "./NutritionModal.vue?vue&type=template&id=bbf751f6"
import script from "./NutritionModal.vue?vue&type=script&lang=js"
export * from "./NutritionModal.vue?vue&type=script&lang=js"
import style0 from "./NutritionModal.vue?vue&type=style&index=0&id=bbf751f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports